@if (showSection) {
    <div class="agpr-formField" role="group" [attr.aria-labelledby]="field.headingId">
        <div
            *ngIf="field.label"
            class="agpr-formField-label agpr-checkboxesContainer-heading"
        >
            {{ field.label | localize }}
        </div>
        <div
            role="list"
            [attr.aria-label]="field.label | localize"
        >
            <ul>
                <li
                    *ngFor="let fieldOption of field.options; let i = index"
                    role="listitem"
                    class="agpr-checkboxesContainer"
                >
                    <agpr-checkbox
                        [id]="id + '.checkboxes_' + i"
                        [(ngModel)]="value"
                        [value]="fieldOption.key"
                        [label]="fieldOption.label"
                        [infoCircleTooltip]="fieldOption.tooltip"
                        [disabled]="fieldOption.disabled"
                        name="checkboxesOptions"
                        [binary]="field.binary"
                        (ngModelChange)="onCheckboxChanged($event)"
                    >
                    </agpr-checkbox>
                </li>
            </ul>
        </div>
        <div
            *ngIf="field.description"
            class="agpr-formField-description"
        >
            {{ field.description | localize }}
        </div>

        <agpr-form-message *ngIf="showError">
            {{ 'Reports.topPosts.oneNetworkRequied' | localize }}
        </agpr-form-message>
    </div>
}
